<template>
  <CDropdown
    class="v3-dropdown-menu"
    v-bind="{ autoClose, placement, variant }"
    @show="isVisible = true"
    @hide="isVisible = false"
  >
    <!-- With variant="nav-item" CoreUI renders the toggle as <a href="#">; activating it
         would follow "#" and jump focus to the top of the page (Deque 2180969: focus moves
         to the header on activate). Prevent the default navigation; CoreUI's own toggle
         handler still runs. Harmless no-op if the toggle renders as a <button>. -->
    <CDropdownToggle component="button" @click.prevent>
      <slot name="toggler" :expanded="isVisible"></slot>
      <div
        v-if="modelValue && !slots.toggler"
        class="d-flex align-items-center"
      >
        <IconButton
          v-if="modelValue.icon"
          class="static"
          :icon="modelValue.icon"
        ></IconButton>
        <span>{{ modelValue.label }}</span>
      </div>
    </CDropdownToggle>
    <CDropdownMenu v-if="items.length">
      <CDropdownItem
        v-for="(item, i) in items"
        :key="i"
        :class="{ active: modelValue && modelValue.value === item.value }"
      >
        <div>
          <CustomCheck
            v-if="checkListMode"
            :model-value="
              useCheckedKey
                ? checkedItems.includes(item.value)
                : preselected
                  ? true
                  : false
            "
            @click="setActiveItem(item)"
            class="d-flex align-items-center dropdown-item-wrap"
            :label="item.label"
          ></CustomCheck>
          <button
            type="button"
            @click="setActiveItem(item)"
            class="dropdown-item-wrap d-flex align-items-center w-100 text-start bg-transparent border-0"
            :class="{ 'py-0 ps-1': item.icon }"
            v-else
          >
            <IconButton
              class="static p-1"
              v-if="item.icon"
              :icon="item.icon"
            ></IconButton>
            <span>{{ item.label }}</span>
          </button>
        </div>
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
import { onMounted, reactive, ref, useSlots } from "vue"
import CustomCheck from "../Form/CustomCheck.vue"
import IconButton from "../Buttons/IconButton.vue"
export default {
  emits: ["update:model-value"],
  components: { CustomCheck, IconButton },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Object,
      default: () => {
        return
      }
    },
    checkListMode: {
      type: Boolean,
      default: false
    },
    autoClose: {
      type: [String, Boolean],
      default: true
    },
    placement: {
      type: String,
      default: "bottom-end"
    },
    variant: {
      type: String,
      default: "nav-item"
    },
    preselected: {
      type: Object,
      default: null
    },
    useCheckedKey: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const checkedItems = reactive([])
    const slots = useSlots()
    /* Expose the dropdown open state so togglers can sync aria-expanded (Deque 2180969). */
    const isVisible = ref(false)
    const setActiveItem = (item) => {
      if (props.checkListMode) {
        if (checkedItems.includes(item.value)) {
          checkedItems.splice(checkedItems.indexOf(item.value), 1)
        } else {
          checkedItems.push(item.value)
        }
      }
      emit("update:model-value", props.checkListMode ? checkedItems : item)
    }
    onMounted(() => {
      if (props.useCheckedKey) {
        const initialCheckedItems = props.items
          .filter((item) => item.checked)
          .map((item) => item.value)
        checkedItems.push(...initialCheckedItems)
      } else if (props.preselected) {
        setActiveItem(props.preselected)
      } else if (!slots.toggler) {
        setActiveItem(props.items[0])
      }
    })
    return {
      setActiveItem,
      slots,
      checkedItems,
      isVisible
    }
  }
}
</script>
